import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { ChargingNetworkWiseConstant } from "./ChargingNetworkWiseConstant";

const initialState = {
  ChargingNetwoekList: [],
  Chargingn: {
    isLoading: false,
  },
};

export const ChargingNetworkWiseReducer = persistReducer(
  {
    storage,
    key: "Chargingwise",
    whitelist: [" Chargingwiselist"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_REQUEST: {
        return {
          ...state,
          ChargingNetwoekList: [],
          Chargingn: {
            isLoading: true,
          },
        };
      }

      case ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_RESPONSE: {
        return {
          ...state,
          ChargingNetwoekList: payload,
          Chargingn: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
